import styled from '@emotion/styled';
import { Dialog } from '@mui/material';

export const SelectRoundCalendarDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: 688px;
    height: 783px;
    border-radius: 10px;
    align-items: center;
    justify-content: center;
    max-width: 100%;

    @media only screen and (max-width: 767px) {
      width: 100%;
      height: 100%;
      border-radius: 0px;
    }
  }

  .calendar-box {
    height: 400px;
  }

  .close-icon {
    font-size: 27px;
    right: 25px;
    top: 20px;
    position: absolute;
    color: #bdbdbd;
  }

  .header-box {
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }

  .select-round-calendar-box {
    width: 608px;
    gap: 12px;
    display: flex;
    flex-direction: column;
    height: 787px;
    display: flex;
    flex-direction: column;
    padding-left: 8px;
    padding-right: 8px;
    margin-top: 24px;
    margin-bottom: 24px;
    overflow: auto;
    overflow-x: hidden;
    ::-webkit-scrollbar {
      width: 0px;
    }

    @media only screen and (max-width: 767px) {
      width: 95%;
    }
  }

  .submit-round-button {
    height: 40px;
    background-color: #00532a;
    color: #ffffff;
    border: 4px;
    display: flex;
    align-items: center;
  }

  .select-round-header-box {
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }

  .choose-round-header-text {
    font-size: 36px;
    font-weight: 700;
    line-height: 43px;
  }

  .choose-round-title-text {
    font-size: 18px;
    font-weight: 600;
    line-height: 18px;
  }

  .title-text {
    font-size: 24px;
    font-weight: 600;
    line-height: 24px;
  }
`;
